<div
  class="pt-2 px-5 max-w-md mx-auto lg:max-w-full lg:px-0 lg:pt-0"
  [style.color]="textColor | contentBuilderColor"
>
  <ng-container *ngIf="basket$ | async as basket">
    <div
      *ngIf="basket.id"
      class="flex items-center mb-4 px-3 py-3"
    >
      <span class="icon icon-group-order text-2xl"></span>
      <span
        *ngIf="basket.user.firstname"
        class="font-accent font-bold pl-4"
      >
        {{ 'basket.group-command-of' | translate }}
        {{ basket.user.firstname }}</span
      >
      <span
        *ngIf="!basket.user.firstname"
        class="font-accent font-bold pl-4"
      >
        {{ 'basket.group-command' | translate }}</span
      >
    </div>
  </ng-container>
  <div
    *ngIf="isGroupedOrderAllowed"
    class="pb-6"
  >
    <app-button-atom
      [size]="'XS'"
      thickSize="S"
      [label]="
        ((basketId$ | async)
          ? 'shop-page.share-my-grouped-order'
          : 'shop-page.create-my-grouped-order'
        ) | translate
      "
      type="light"
      class="dot dot-2"
      [icon]="'icon-group-order'"
      (click)="openGroupOrderModal()"
    ></app-button-atom>
  </div>
  <h1
    class="font-accent font-bold text-2xl lg:text-3xl"
    [style.color]="headingColor | contentBuilderColor"
  >
    {{ 'basket.overview' | translate }}
  </h1>
  <ng-container *ngIf="!(orderValidationInProgress$ | async); else mainLoading">
    <ng-container
      *ngIf="(basketId$ | async) && (reconstructedShareOrderBasket$ | async) as reconstructedBasket"
    >
      <ng-container *ngIf="reconstructedBasket.length; else emptyBasket">
        <div *ngFor="let elem of reconstructedBasket">
          <p
            class="py-2 px-1 text-white text-sm text-center mt-4 font-base font-bold"
            [style.color]="headingColor | contentBuilderColor"
          >
            <span *ngIf="elem.user.firstname">{{ elem.user.firstname }}</span>
            <span *ngIf="!elem.user.firstname">{{ 'basket.anonymous' | translate }}</span>
            <span *ngIf="(userId$ | async) === elem.user.id">
              ({{ 'basket.you' | translate }})</span
            >
          </p>
          <ul>
            <li
              *ngFor="let item of elem.items; let index = index"
              class="border-neutral-300 {{ item.product?.id }}"
              [ngClass]="{ 'border-t': index > 0 }"
            >
              <div
                class="flex align-center justify-center gap-3.5"
                *ngIf="basket$ | async as basket"
              >
                <app-overview-cart-item-atom
                  class="flex-auto"
                  [id]="item.itemId"
                  [isProductExists]="!!item.product?.[productKeys.Id]"
                  [name]="item.product?.[productKeys.Name] ?? 'INVALID'"
                  [groupAdditionsItems]="item.product?.additions?.items"
                  [groupCompoundItems]="item.product?.categories"
                  [quantity]="item.quantity"
                  [price]="item.price"
                  [formatPrice]="true"
                  [isOwner]="(userId$ | async) === elem.user.id"
                  [displayRemoveIcon]="
                    (userId$ | async) === elem.user.id || basket.user.id === (userId$ | async)
                  "
                  [isBasketOrder]="true"
                  (updateItem)="onUpdateItem(item.itemId, item.id)"
                  (removeItem)="onRemoveBasketItem(item.id)"
                ></app-overview-cart-item-atom>
              </div>
            </li>
          </ul>
          <div
            *ngFor="let coupon of elem.subCart.coupons"
            class="flex justify-between py-3 border-neutral-300 border-b"
            [class.opacity-50]="coupon.removeInProgress"
          >
            <div class="font-normal text-sm leading-snug lg:text-base">
              <div>
                <ng-container *ngIf="coupon.name">
                  {{ coupon.name }}
                </ng-container>
                <ng-container *ngIf="!coupon.name">
                  {{ 'basket.discount-voucher' | translate }}
                  «{{ coupon.code }}»
                </ng-container>
              </div>
              <div
                *ngIf="coupon.type === 'ERROR'"
                class="text-xs text-error-800"
              >
                <ng-container *ngIf="coupon.error">
                  {{ coupon.error }}
                </ng-container>
                <ng-container *ngIf="!coupon.error">
                  {{ 'basket.invalid-voucher' | translate }}
                </ng-container>
              </div>
              <div *ngIf="(userId$ | async) === elem.user.id">
                <a
                  (click)="onRemoveCoupon(coupon)"
                  class="text-primary-600 cursor-pointer"
                  >{{ 'basket.delete' | translate }}</a
                >
              </div>
            </div>
            <div class="flex flex-row justify-end items-center">
              <div
                class="icon icon-coupon-3 text-neutral-400 pl-4"
                *ngIf="coupon.type !== 'ERROR'"
              ></div>
              <div
                class="icon icon-warning-circle text-error-800 pl-4"
                *ngIf="coupon.type === 'ERROR'"
              ></div>
              <div
                class="text-sm leading-5 w-20 text-right"
                *ngIf="coupon.type !== 'ERROR'"
              >
                –
                <app-price-atom
                  [bold]="false"
                  [amount]="coupon.amount_off"
                  [format]="true"
                ></app-price-atom>
              </div>
            </div>
          </div>
          <div
            *ngIf="elem.subCart.total || elem.subCart.total === 0"
            class="flex justify-between py-3 text-base"
          >
            <span class="font-accent font-bold">{{ 'basket.subtotal' | translate }} :</span>
            <app-price-atom
              [amount]="elem.subCart.total"
              [bold]="true"
              [format]="true"
            ></app-price-atom>
          </div>
          <div
            *ngIf="basket$ | async as basket"
            class="pb-3"
          >
            <a
              *ngIf="basket.user.id === (userId$ | async) && basket.user.id !== elem.user.id"
              class="flex items-center cursor-pointer text-secondary-600"
              (click)="removeUserFromCart(elem.user.id)"
            >
              <span class="icon icon-cross mr-2"></span>
              <span>{{ 'group-order-modal.delete-guest-button' | translate }}</span>
            </a>
          </div>
        </div>
      </ng-container>
      <ng-template #emptyBasket>
        <div class="max-w-screen-sm mx-auto px-5 py-5 my-5">
          <p class="font-accent p-4 rounded rounded-sm bg-highlight-50 text-center">
            {{ 'basket.empty-basket' | translate }}
          </p>
        </div>
      </ng-template>
    </ng-container>
    <ng-container *ngIf="!(reconstructedShareOrderBasket$ | async)?.length">
      <ng-container *ngIf="reconstructedCart$ | async as cartByShop; else loading">
        <div *ngIf="cartByShop.length; else emptyCart">
          <div *ngFor="let cart of cartByShop">
            <h2
              class="mt-8xs font-accent font-bold text-base"
              [style.color]="secondaryTextColor | contentBuilderColor"
            >
              {{ cart[reconstructedCartKeys.Shop][shopKeys.Name] }}
            </h2>
            <ul>
              <li
                *ngFor="let item of cart[reconstructedCartKeys.Items]; let index = index"
                class="border-neutral-300 {{
                  item[reconstructedCartItemKeys.Item][cartItemKeys.Id]
                }}"
                [ngClass]="{ 'border-t': index > 0 }"
              >
                <app-overview-cart-item-atom
                  [id]="item[reconstructedCartItemKeys.Item][cartItemKeys.Id]"
                  [isProductExists]="!!item[reconstructedCartItemKeys.Product]?.[productKeys.Id]"
                  [name]="item[reconstructedCartItemKeys.Product]?.[productKeys.Name] ?? 'INVALID'"
                  [childItems]="item[reconstructedCartItemKeys.ChildCompoundItems]"
                  [quantity]="item[reconstructedCartItemKeys.Item][cartItemKeys.Quantity]"
                  [price]="item[reconstructedCartItemKeys.UnitPrice]"
                  [textColor]="textColor"
                  [productNameColor]="productNameColor"
                  [productDetailsColor]="productDetailsColor"
                  (updateItem)="onUpdateItem($event)"
                  (removeItem)="onRemoveBasketItem($event)"
                ></app-overview-cart-item-atom>
              </li>
            </ul>
          </div>
        </div>
        <ng-template #emptyCart>
          <div class="max-w-screen-sm mx-auto px-5 py-5 my-5">
            <p class="font-accent p-4 rounded rounded-sm bg-highlight-50 text-center">
              {{ 'basket.empty-basket' | translate }}
            </p>
          </div>
        </ng-template>
      </ng-container>

      <ng-template #loading>
        <div class="pt-8">
          <ng-container *ngFor="let i of [].constructor(2)">
            <div class="flex justify-between pb-3 max-w-screen-sm flex flex-col">
              <div class="w-full flex flex-row justify-between">
                <div class="animate-pulse h-4 bg-neutral-100 rounded w-32 mb-3"></div>
              </div>
              <ng-container *ngFor="let j of [].constructor(3)">
                <div class="flex justify-between pb-2 max-w-screen-sm">
                  <div class="w-full flex flex-row justify-between">
                    <div class="animate-pulse h-4 bg-neutral-50 rounded w-7/12 mb-2"></div>
                    <div class="animate-pulse h-4 bg-neutral-50 rounded w-14 mb-2"></div>
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </div>
      </ng-template>
    </ng-container>
  </ng-container>

  <ng-template #mainLoading>
    <div
      *ngFor="let i of [].constructor(5)"
      class="flex justify-between items-center py-3 border-b border-neutral-300 w-full"
    >
      <div class="w-9/12 flex">
        <p class="h-4 ml-2 animate-pulse bg-neutral-200 w-7/12"></p>
      </div>
      <div class="h-4 animate-pulse bg-neutral-200 w-10"></div>
    </div>
  </ng-template>
</div>
